import { ICurrentUser } from '../model/types';

export const getUserInitials = (user: ICurrentUser): string => {
  if (user.name) {
    return `${user.name.charAt(0)}`.toUpperCase();
  }

  return user.email.charAt(0).toUpperCase();
};
